import React, { useState } from "react";

import { AsesorsContext as Context } from "./index";

import { alertSuccess } from "../../../Shared/Utils/alertMessages.js";

import {
  alertToastErrorFromResponse,
  getErrorsArrayMessageFromHtttpResponse,
} from "../../../Shared/Utils/errorUtils.js";
import {
  createAsesorApi,
  deleteAsesorApi,
  getAsesorsApi,
  getContactAsesorsApi,
  showAsesorApi,
  updateAsesorApi,
} from "../Api/AsesorsApi.js";
import {
  errorGettingData,
  genericError,
  successDeleted,
} from "../../../Shared/Constants/index.jsx";

const AsesorsProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [succesCreated, setSuccesCreated] = useState(false);

  const getAsesors = async (id) => {
    setLoading(true);
    try {
      let response = await getAsesorsApi(id);
      let data = response.data;

      if (response.result === "success") {
        setTableData(
          data.items.map((asesor) => ({
            ...asesor,
            name: `${asesor.first_name} ${asesor.last_name}`,
          }))
        ); // Append new data
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTableData([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertToastErrorFromResponse(genericError, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        setLoading,
        apiErrors,
        setItem,
        item,
        loading,
        tableData,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        totalRows,
        setApiErrors,
        succesCreated,
        getAsesors,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default AsesorsProvider;
